var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewAssetRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-New_Asset_Request"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New_Asset_Request",
    "data-name": "New Asset Request",
    clipPath: "url(#clip-New_Asset_Request)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9012",
    "data-name": "Group 9012",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_19895",
    "data-name": "Path 19895",
    fill: "#0069bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.75 21 C 5.098130226135254 21 0.5 16.40187072753906 0.5 10.75 C 0.5 5.098130226135254 5.098130226135254 0.5 10.75 0.5 C 16.40187072753906 0.5 21 5.098130226135254 21 10.75 C 21 16.40187072753906 16.40187072753906 21 10.75 21 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.75 1 C 5.373830795288086 1 1 5.373830795288086 1 10.75 C 1 16.12617111206055 5.373830795288086 20.5 10.75 20.5 C 16.12617111206055 20.5 20.5 16.12617111206055 20.5 10.75 C 20.5 5.373830795288086 16.12617111206055 1 10.75 1 M 10.75 0 C 16.68705940246582 0 21.5 4.81294059753418 21.5 10.75 C 21.5 16.68705940246582 16.68705940246582 21.5 10.75 21.5 C 4.81294059753418 21.5 0 16.68705940246582 0 10.75 C 0 4.81294059753418 4.81294059753418 0 10.75 0 Z",
    stroke: "none",
    fill: "#0081ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10464",
    "data-name": "Group 10464",
    transform: "translate(-172.564 -85.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8254",
    "data-name": "Group 8254",
    transform: "translate(177 91.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8253",
    "data-name": "Group 8253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18424",
    "data-name": "Path 18424",
    d: "M248.351,206.792a2.064,2.064,0,1,1,3.722,1.232c-.026.035-.03.056,0,.09q.5.549,1,1.1a.639.639,0,0,1,.136.209.325.325,0,0,1-.163.387.339.339,0,0,1-.421-.073q-.373-.409-.744-.819c-.1-.111-.2-.22-.3-.333a.071.071,0,0,0-.11-.018,2.023,2.023,0,0,1-1.073.291,2.064,2.064,0,0,1-2.03-1.827C248.36,206.952,248.357,206.872,248.351,206.792Zm2.069-1.645a1.645,1.645,0,1,0,1.643,1.657A1.652,1.652,0,0,0,250.42,205.147Z",
    transform: "translate(-241.621 -201.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18425",
    "data-name": "Path 18425",
    d: "M114.031,157.6c0-.948,0-1.9,0-2.844a.365.365,0,0,1,.422-.377,5.593,5.593,0,0,0,.587,0,.37.37,0,0,1,.435.39c-.006.943,0,1.886,0,2.829s0,1.891,0,2.837a.688.688,0,0,1,0,.1.336.336,0,0,1-.365.288c-.224,0-.449,0-.673,0-.257,0-.4-.125-.4-.355Q114.031,159.038,114.031,157.6Z",
    transform: "translate(-112.32 -152.825)",
    fill: "rgba(255,255,255,0.5)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18436",
    "data-name": "Path 18436",
    d: "M114.031,157.6c0-.948,0-1.9,0-2.844a.365.365,0,0,1,.422-.377,5.593,5.593,0,0,0,.587,0,.37.37,0,0,1,.435.39c-.006.943,0,1.886,0,2.829s0,1.891,0,2.837a.688.688,0,0,1,0,.1.336.336,0,0,1-.365.288c-.224,0-.449,0-.673,0-.257,0-.4-.125-.4-.355Q114.031,159.038,114.031,157.6Z",
    transform: "translate(-109.563 -152.825)",
    fill: "rgba(255,255,255,0.5)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18430",
    "data-name": "Path 18430",
    d: "M363.821,120.869c0,.325,0,.65,0,.975a.293.293,0,0,1-.569.1.5.5,0,0,1-.018-.153c0-.5-.005-1,0-1.5,0-.083-.022-.106-.106-.105-.509,0-1.018,0-1.527,0a.3.3,0,1,1-.027-.592q.979,0,1.959,0a.294.294,0,0,1,.29.312c0,.322,0,.644,0,.966Z",
    transform: "translate(-351.195 -119.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18431",
    "data-name": "Path 18431",
    d: "M79.36,120.269v.135q0,.746,0,1.493a.3.3,0,0,1-.276.324.292.292,0,0,1-.314-.295c0-.132,0-.265,0-.4q0-.751,0-1.5a.31.31,0,0,1,.355-.353h1.855a.3.3,0,0,1,.334.286.3.3,0,0,1-.32.307H79.36Z",
    transform: "translate(-78.767 -119.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18432",
    "data-name": "Path 18432",
    d: "M80.516,325.7h-.923a.3.3,0,0,1-.345-.341q-.008-.94-.013-1.881a.293.293,0,0,1,.158-.286.286.286,0,0,1,.3.016.317.317,0,0,1,.131.293q0,.746.006,1.492c0,.117,0,.118.117.117.509,0,1.018-.008,1.527-.009a.294.294,0,1,1,.005.587c-.322,0-.644,0-.966,0Z",
    transform: "translate(-79.218 -316.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18433",
    "data-name": "Path 18433",
    d: "M296.481,155.608c-.658.065-1.024.639-1.027.207,0-.338,0-.774,0-1.112,0-.2.176-.311.487-.312.083,0,.167,0,.25,0,.222.007.412.124.414.266.006.308,0,.615,0,.923A.558.558,0,0,1,296.481,155.608Z",
    transform: "translate(-288.225 -152.834)",
    fill: "rgba(255,255,255,0.5)",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_273",
    "data-name": "Ellipse 273",
    cx: 1.646,
    cy: 1.645,
    rx: 1.646,
    ry: 1.645,
    transform: "translate(7.15 3.959)",
    fill: "rgba(255,255,255,0.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18435",
    "data-name": "Path 18435",
    d: "M201.3,155.991a2.939,2.939,0,0,0-.716-.472c-.386-.167-.668-.274-.668-.274,0-1.35,0,.415,0-.934a.279.279,0,0,1,.02-.115.363.363,0,0,1,.332-.157q.336,0,.673,0c.2,0,.347.092.359.222,0,.022,0,.044,0,.067C201.3,155,201.3,155.315,201.3,155.991Z",
    transform: "translate(-13.285 -61.125)",
    fill: "rgba(255,255,255,0.5)",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAssetRequest);
export default __webpack_public_path__ + "static/media/New Asset Request.fa37683057c3414864d56c2bc6d01231.svg";
export { ForwardRef as ReactComponent };